import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditAvisoEnLaWebComponent } from "./edit-aviso-en-la-web/edit-aviso-en-la-web.component";

@Component({
  selector: "app-categorias",
  templateUrl: "./aviso-en-la-web.component.html",
  styleUrls: ["./aviso-en-la-web.component.scss"],
})
export class AvisoEnLaWebComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditAvisoEnLaWebComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
